// First JSX Component 

export default {
  props: ['value'],
  data: function() {
    return {
      showSpan: true,
    }
  },
  methods: {
    toggleInput: function(event) {
      this.showSpan = false;
      setTimeout(() => {
        console.log(this.$refs['input']);
        this.$refs.input.focus();
      }, 10);
    },
    blurInput: function(event) {
      this.showSpan = true;
      this.$emit('change', event.target.value);
    }
  },
  render(createElement) {
    return (
    <div class="dt-editable-span">
      { this.showSpan 
        ? <span on-click={ this.toggleInput } class="dt-editable-span--span">
        { this.value }
        </span>  
        : <input
          ref="input"
          type="text"
          class="dt-editable-span--input"
          on-blur={ this.blurInput }
          value = { this.value }
        />
      }
    </div>
    );
  }
}